import { render, staticRenderFns } from "./ConsignatariaIndex.vue?vue&type=template&id=f60ceb60&"
import script from "./ConsignatariaIndex.vue?vue&type=script&lang=js&"
export * from "./ConsignatariaIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConsignatariaIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports